import { render, staticRenderFns } from "./batchPriceMaintain.vue?vue&type=template&id=cfcf648a&scoped=true"
import script from "./batchPriceMaintain.vue?vue&type=script&lang=js"
export * from "./batchPriceMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcf648a",
  null
  
)

export default component.exports